import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Kernel?",
  "description": "",
  "published": "2007-03-01T00:00:00.000Z",
  "redirect_from": ["/blog/kernel/swizec/274"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ne vem katero verzijo linuxovega kernela tale video vizualizira, ampak kar pokaze izgleda neverjetno fascinantno.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      